<template>
    <div class="content">
        <div class="header flex-row">
            <div class="step-item flex-column" style="color: #fff">
                <img src="../../assets/img/icon-infoed.svg" />
                填写预约信息
            </div>
            <div class="step-item flex-column">
                <img src="../../assets/img/icon-order.svg" />
                确认订单信息
            </div>
            <div class="step-item flex-column">
                <img src="../../assets/img/icon-settlement.svg" />
                订单预约待审核
            </div>
        </div>
        <div class="section">
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>选择日期</span>
                </div>

                <!-- <img src="../../assets/img/icon-right.svg"> -->
            </div>
            <!-- 	<div class="nav flex-row">
				<div class="nav-item flex-column" v-for="(item,index) in navlist" :key="index">
					{{item.week}}
					<span>{{item.weekE}}</span>
				</div>
			</div> -->
            <div class="datelist flex-row">
                <div
                    class="item flex-column"
                    :class="
                        item.reception || item.stop || item.stopEntering
                            ? 'notchecked'
                            : currentDate == index
                            ? 'activeDate'
                            : ''
                    "
                    v-for="(item, index) in dateList"
                    :key="index"
                    @click="chooseDate(index, item.day)"
                >
                    <span>{{ item.week }}</span>
                    <span>{{ item.day }}</span>
                    <!-- <span v-show="index!=0">2000/2000</span> -->
                    <!-- stop是否闭馆：true为闭馆，StopEntering是否停止入馆：true为停止，reception是否接待日：true为非接待日-->
                    <span v-if="!item.reception && !item.stop && !item.stopEntering">可预约</span>
                    <span v-else>不可预约</span>
                    <img
                        class="today"
                        v-if="date == item.day"
                        src="../../assets/img/icon-today.svg"
                    />
                </div>
            </div>
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>选择时段</span>
                </div>
            </div>
            <div class="timeInterval flex-row">
                <div
                    class="item flex-column"
                    v-for="(item, index) in timeIntervalList"
                    :key="index"
                    :class="!item.choose ? 'notchecked' : currentTime == index ? 'activeTime' : ''"
                    @click="chooseTime(index)"
                >
                    <span>{{ item.startTime }}-{{ item.endTime }}</span>
                    <!--					<span>剩余库存:{{item.surplusStock}}</span>-->
                    <span v-if="item.choose">可预约</span>
                    <span style="color: #737373" v-else>停售</span>
                </div>
            </div>
            <!--			<div class="tag flex-row">-->
            <!--						<div class="flex-column ">-->
            <!--				<img src="../../assets/img/btzs-icon.png">-->
            <!--				<span>参观票数</span></div>-->
            <!--			-->
            <!--			</div>-->
            <!--			<div class="ticketbox flex-row">-->
            <!--				<div class="item flex-row" v-for="(item,index) in ProductList" :key="index">-->
            <!--					<img class="cover" src="../../assets/img/icon-avatar.png">-->
            <!--					<div class="name">-->
            <!--						{{item.productName}}-->
            <!--						<span>￥{{item.price}}</span>-->
            <!--					</div>-->
            <!--					<div class="numbox flex-row">-->
            <!--						<img src='../../assets/img/icon-reduce.svg' @click="reduceTicket(index)">-->
            <!--						<el-input type="text" v-model="item.number"></el-input>-->
            <!--						<img src='../../assets/img/icon-add1.svg' @click="addTicket(index)">-->
            <!--					</div>-->
            <!--				</div>-->
            <!--			</div>-->
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>团队信息</span>
                </div>
            </div>
            <div class="teamInfo">
                <!-- 	<div class="tab flex-row">
					<div class="tab-item" :class="currentTab==0?'activeNav':''" @click="changeNav(0)">
						学校预约
					</div>
					<div class="tab-item" :class="currentTab==1?'activeNav':''" @click="changeNav(1)">
						单位预约
					</div>
				</div> -->
                <div class="info">
                    <div class="left-box">
                        <!-- <div class="item shcoolName flex-row" v-if="currentTab==0">
							<span>*学校名称</span>
							<el-input type="text" placeholder="请输入学校名称" v-model="schoolName">
							</el-input>
						</div>
						<div class="item shcoolName flex-row" v-if="currentTab==1">
							<span>*单位名称</span>
							<el-input type="text" placeholder="请输入单位名称" v-model="unitName">
							</el-input>
						</div> -->
                        <div class="leader flex-row">
                            <div class="item flex-row">
                                <span>{{ this.teamType == 1 ? "导游姓名" : "负责人姓名" }}</span>
                                <el-input
                                    type="text"
                                    :placeholder="
                                        this.teamType == 1
                                            ? '请输入导游姓名'
                                            : '请输入负责人姓名姓名'
                                    "
                                    v-model="name"
                                >
                                </el-input>
                            </div>
                            <!-- <div class="item flex-row" v-if="teamType == 0">
                                <span>身份证号</span>
                                <el-input
                                    type="text"
                                    :placeholder="
                                        this.teamType == 1
                                            ? '请输入导游身份证号'
                                            : '请输入领队人身份证号'
                                    "
                                    v-model="Idcard"
                                >
                                </el-input>
                            </div> -->
                            <div class="item flex-row">
                                <span>联系电话</span>
                                <el-input type="text" placeholder="请输入联系电话" v-model="phone">
                                </el-input>
                            </div>
                        </div>
                    </div>
                    <div class="right-box flex-row">
                        <div class="item flex-row">
                            <span>参观人数</span>
                            <el-input
                                style="width: 398px"
                                type="number"
                                placeholder="请输入参观人数"
                                v-model="userCount"
                                :min="1"
                                @blur="onBlur"
                            >
                            </el-input>
                        </div>
                        <!-- <div class="uploadFile flex-row">
                            <span class="name">参观名单</span>
                            <el-upload
                                class="upload-demo"
                                ref="upload"
                                :action="uploadUrl"
                                :headers="headerObj"
                                accept=".xlsx"
                                :data="param"
                                :on-success="uploadSuccess"
                                :before-upload="beforeUpload"
                                :multiple="false"
                                :show-file-list="false"
                                :limit="1"
                            >
                                <div class="uploadbox flex-column">
                                    <div v-if="fileName == ''" class="flex-column">
                                        <img src="../../assets/img/icon-upload2.svg" />

                                        <div class="uploadbox-title">
                                            请先<span
                                                style="
                                                    color: #bb2916;
                                                    border-bottom: 1px solid #af0b0b;
                                                "
                                                >下载模板</span
                                            >,填写完成后点击上传参观名
                                        </div>
                                    </div>
                                    <div class="fileName ellipsis1" v-else>{{ fileName }}</div>
                                </div>
                            </el-upload>
                            <div class="download flex-row" @click="downModel">
                                <img src="../../assets/img/icon-download.svg" />
                                <span>下载模板</span>
                            </div>
                        </div> -->

                        <!--						<div class=" uploadFile flex-row" v-if="teamType==0||teamType==2">-->
                        <!--							<span class="name">介绍信</span>-->
                        <!--							<el-upload class="upload-demo" ref="uploadLetter" :action="uploadFileUrl"-->
                        <!--								:headers="headerObj" accept=".pdf" :on-success="uploadLetterSuccess" :multiple='false'-->
                        <!--								:show-file-list='false' :limit="1">-->
                        <!--								<div class="uploadbox flex-column">-->
                        <!--									<div v-if="LetterfileName==''" class="flex-column">-->
                        <!--										<img src='../../assets/img/jieshao.svg'>-->
                        <!--										点击上传介绍信-->
                        <!--									</div>-->
                        <!--									<div class="fileName ellipsis1" v-else>{{LetterfileName}}</div>-->
                        <!--								</div>-->
                        <!--							</el-upload>-->
                        <!--							&lt;!&ndash; <div class="download flex-row" @click="downModel">-->
                        <!--								<img src='../../assets/img/icon-download.svg'>-->
                        <!--								<span>下载模板</span>-->
                        <!--							</div> &ndash;&gt;-->
                        <!--						</div>-->
                        <div class="uploadFile flex-row">
                            <span class="name">承诺书</span>
                            <el-upload
                                class="upload-demo"
                                ref="uploadLetter1"
                                :action="uploadFileUrl"
                                :headers="headerObj"
                                accept=".pdf"
                                :on-success="uploadLetterSuccess1"
                                :multiple="false"
                                :show-file-list="false"
                                :limit="1"
                            >
                                <div class="uploadbox flex-column">
                                    <div
                                        v-if="instructionsProveFileUrlName == ''"
                                        class="flex-column"
                                    >
                                        <img src="../../assets/img/jieshao.svg" />
                                        点击上传承诺书
                                    </div>
                                    <div class="fileName ellipsis1" v-else>
                                        {{ instructionsProveFileUrlName }}
                                    </div>
                                </div>
                            </el-upload>
                            <!-- &lt;!&ndash; -->
                            <div class="download flex-row" @click="downModel1">
                                <img src="../../assets/img/icon-download.svg" />
                                <span>下载模板</span>
                            </div>
                            <!-- &ndash;&gt; -->
                        </div>
                        <!-- <div class="uploadFile flex-row" v-if="teamType == 1">
                            <span class="name">行程单</span>
                            <el-upload
                                class="upload-demo"
                                ref="uploadTrip"
                                :action="uploadFileUrl"
                                :headers="headerObj"
                                accept=".pdf"
                                :on-success="uploadTripSuccess"
                                :multiple="false"
                                :show-file-list="false"
                                :limit="1"
                            >
                                <div class="uploadbox flex-column">
                                    <div v-if="TripfileName == ''" class="flex-column">
                                        <img src="../../assets/img/from.svg" />
                                        <div class="uploadbox-title">点击上传电子行程单</div>
                                    </div>
                                    <div class="fileName ellipsis1" v-else>{{ TripfileName }}</div>
                                </div>
                            </el-upload>
                            下载模版须注释
                            <div class="download flex-row" @click="downModel">
								<img src='../../assets/img/icon-download.svg'>
								<span>下载模板</span>
							</div>
                        </div> -->
                        <div class="uploadFile flex-row">
                            <span class="name">身份证正面</span>
                            <el-upload
                                class="upload-demo"
                                ref="uploadTrip"
                                :action="uploadFileUrl"
                                :headers="headerObj"
                                accept=".png,.jpeg,.jpg"
                                :on-success="uploadTripSuccess"
                                :multiple="false"
                                :show-file-list="false"
                                :limit="1"
                            >
                                <div class="uploadbox flex-column">
                                    <div v-if="idCardFileUrl == ''" class="flex-column">
                                        <img src="../../assets/img/from.svg" />
                                        <div class="uploadbox-title">点击上传身份证正面照</div>
                                    </div>
                                    <img
                                        style="width: auto; height: 100%"
                                        :src="idCardFileUrl"
                                        v-else
                                        alt=""
                                    />
                                    <!-- <div class="fileName ellipsis1" v-else>{{ TripfileName }}</div> -->
                                </div>
                            </el-upload>
                        </div>
                        <div class="uploadFile flex-row">
                            <span class="name">身份证反面</span>
                            <el-upload
                                class="upload-demo"
                                ref="uploadTourise"
                                :action="uploadFileUrl"
                                :headers="headerObj"
                                accept=".jpg,.png,.jpeg"
                                :on-success="uploadTouriseSuccess"
                                :multiple="false"
                                :show-file-list="false"
                                :limit="1"
                            >
                                <div class="uploadbox flex-column">
                                    <div v-if="reverseIdCardFileUrl == ''" class="flex-column">
                                        <img src="../../assets/img/tourise.svg" />
                                        <div class="uploadbox-title">点击上传身份证反面照</div>
                                    </div>
                                    <img
                                        style="width: auto; height: 100%"
                                        :src="reverseIdCardFileUrl"
                                        v-else
                                        alt=""
                                    />
                                </div>
                            </el-upload>
                        </div>
                        <!-- <div class="uploadFile flex-row" v-if="teamType == 1">
                            <span class="name">导游证</span>
                            <el-upload
                                class="upload-demo"
                                ref="uploadTourise"
                                :action="uploadFileUrl"
                                :headers="headerObj"
                                accept=".jpg,.png,"
                                :on-success="uploadTouriseSuccess"
                                :multiple="false"
                                :show-file-list="false"
                                :limit="1"
                            >
                                <div class="uploadbox flex-column">
                                    <div v-if="TourisefileName == ''" class="flex-column">
                                        <img src="../../assets/img/tourise.svg" />
                                        <div class="uploadbox-title">点击上传导游证</div>
                                    </div>
                                    <div class="fileName ellipsis1" v-else>
                                        {{ TourisefileName }}
                                    </div>
                                </div>
                            </el-upload>
                        </div> -->
                        <div class="flex-row textarea" v-if="teamType != 1">
                            <span class="name">备注留言</span>
                            <el-input
                                type="textarea"
                                placeholder="请输入备注内容"
                                v-model="remark"
                                resize="none"
                            >
                            </el-input>
                        </div>
                        <div class="flex-row textarea1" v-else>
                            <span class="name">备注留言</span>
                            <el-input
                                type="textarea"
                                placeholder="请输入备注内容"
                                v-model="remark"
                                resize="none"
                            >
                            </el-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>温馨提示</span>
                </div>
            </div>
            <div class="tips">
                <div class="detail">
                    <div class="item flex-row">
                        <img src="../../assets/img/icon-tip1.png" />
                        团队需至少提前三天在四川大学博物馆官网或微信公众号预约购票，到团当日无法预约当天票。
                    </div>
                    <div class="item flex-row">
                        <img src="../../assets/img/icon-tip1.png" />
                        参观日请联系人提前组织好团队，按照二维码下方的进场时间从团队入口有序扫码进场，超过预约时间30分钟，二维码失效，无法入场。
                    </div>
                    <div class="item flex-row">
                        <img src="../../assets/img/icon-tip1.png" />
                        开馆时间:09:00，停止入馆时间:16:30，闭馆时间:17:00。
                    </div>
                    <div class="item flex-row">
                        <img src="../../assets/img/icon-tip1.png" />
                        咨询电话028-85412543，028-85400772。
                    </div>
                </div>
                <img class="line" src="../../assets/img/icon-line.svg" />
            </div>
            <div class="btnbox flex-row">
                <!-- 	<div class="backbtn">
					返回上一步
				</div> -->
                <!-- <router-link to="TeamConfirmOrder"> -->
                <div class="prevbtn cursorp" @click="Confirm">进入下一步</div>
                <!-- </router-link> -->
            </div>
        </div>
        <Tips :isShowTips="visibleDig" @changeDialog="getData" v-if="visibleDig"></Tips>
        <noticeDig :html="nodeHtml" :show.sync="showNotice" v-if="showNotice && !visibleDig" />
    </div>
</template>

<script>
import {
    login,
    AppointmentDay,
    getTimeSlotsLimit,
    getProductList,
    BaseUrl,
    createOrder,
    merchantNo,
    checkIsTeam,
    realNameAuth,
    teamConfigList,
} from "../../utils/http.js";
import Tips from "../Dialog/Tips";
import noticeDig from "../Dialog/noticeDig.vue";
import tool from "@/utils/tools";
import Api from "@/utils/common.js"; //公共方法
import IdentityCodeValid from "@/utils/IdentityCodeValid";
export default {
    name: "ReservationInfo",
    components: {
        Tips,
        noticeDig,
    },
    data() {
        return {
            idCardFileUrl: "", //身份证正面
            reverseIdCardFileUrl: "", //身份证反面
            touristlist: [1, 2, 3],
            timeIntervalList: [],
            dateList: [],
            ProductList: [],
            currentTab: 0,
            number: 0,
            isTeam: false,
            visibleDig: false,
            now: tool.formateDate(new Date()),
            teamType: "",
            schoolName: "",
            unitName: "",
            name: "",
            Idcard: "",
            phone: "",
            userCount: null,
            remark: "",
            currentDate: -1, //选中日期
            currentTime: null, //选中时段
            headerObj: {
                Authorization: tool.getStore("token"),
            }, //请求头
            uploadUrl: `${BaseUrl}/api-api/app/clientHelper/uploadUserInfo`, //上传名单接口请求地址
            uploadFileUrl: `${BaseUrl}/api-cms/file/upload`, //上传文件接口请求地址
            param: {
                teamType: "",
            },
            // 名单路径和名称
            fileName: "",
            filePath: "",
            instructionsProveFileUrl: "", //承诺书
            instructionsProveFileUrlName: "", //承诺书名称
            // 介绍信路径和名称
            LetterfileName: "",
            LetterfilePath: "",
            // 电子行程单路径和名称
            TripfileName: "",
            TripfilePath: "",
            // 导游证路径和名称
            TourisefileName: "",
            TourisefilePath: "",
            products: [],
            showNotice: false, //须知弹窗
            nodeHtml: "", //须知
        };
    },
    mounted() {
        // 获取当前日期
        let date = Api.getDate();
        this.date = date;
        let token = tool.getStore("token");
        if (token == null || token == undefined || token == "") {
            // 获取地址拆分
            let url = window.location.href.split("?")[1].split("&");
            console.log(url);
            let getskey = url[1].split("=")[1];
            let getredirect_url = url[2].split("=")[1];
            // 解码skey
            let skey = decodeURIComponent(getskey);
            // 解码登录过期重定向地址
            let loginExpiredUrl = decodeURIComponent(getredirect_url);
            localStorage.setItem("loginExpiredUrl", loginExpiredUrl); //将重定向地址存入缓存
            this.skey = skey;
            this.login();
            return;
        }
    },
    // 被 keep-alive 缓存的组件激活时调用。
    activated() {
        let token = tool.getStore("token");
        if (token != null && token != undefined && token != "") {
            this.checkIsTeam();
            this.isTeam = tool.getStore("isTeam");
            this.teamType = tool.getStore("teamType");
            // this.visibleDig = !isteam
            // 重新获取token
            let headerObj = this.headerObj;
            headerObj.Authorization = token;
            this.headerObj = headerObj;
        }
    },
    // 被 keep-alive 缓存的组件失活时调用。
    deactivated() {},
    methods: {
        onBlur() {
            this.userCount = Math.floor(this.userCount);
        },

        changeNav(val) {
            this.currentTab = val;
        },

        //获取团队预约须知
        getTeamConfigList() {
            teamConfigList().then(res => {
                console.log("11", res);
                if (res.code == 0) {
                    if (res.data.teamconfig.length) {
                        this.nodeHtml = res.data.teamconfig[0].bookingNotes;
                        this.showNotice = true;
                    }
                }
            });
        },

        // 查询团队认证状态
        checkIsTeam(param) {
            checkIsTeam(param).then(res => {
                this.teamInfo = res.data;
                // 还未认证或还未审核通过显示团队认证弹框
                if (res.data.stateFlag != 1) {
                    if (res.data.teamName != null && res.data.teamName != "") {
                        // 团队名称不为空，表示已经提交认证，在审核中，否则是还未提交认证
                        this.visibleDig = true;
                        localStorage.setItem("isExamine", 1);
                    } else {
                        localStorage.setItem("isExamine", 0);
                        this.visibleDig = true;
                    }
                } else {
                    //通过审核时将isExamine设置为1 展示审核页面
                    localStorage.setItem("isExamine", 1);
                    // 更新本地团队类型
                    localStorage.setItem("teamType", res.data.teamType);
                    this.teamType = res.data.teamType;
                    if (!this.teamInfo.effectiveStateFlag) {
                        this.visibleDig = true;
                        return;
                    }
                    // 获取参观日期  订单来源（2 官网）
                    this.AppointmentDay({
                        type: this.teamType,
                    });
                    // 获取产品数据
                    this.getProductList({
                        orderType: 1, //门票类型（1团队预约）
                        sourceType: 2, //订单来源（2官网）
                        teamType: this.teamType, //团队类型
                    });
                    this.getTeamConfigList();
                }
            });
        },
        // 选择参观日期
        chooseDate(idx, date) {
            let dateList = this.dateList;
            //非参观日或停止售票或停止入馆为true时，不做操作，不可预约
            if (dateList[idx].reception || dateList[idx].stop || dateList[idx].stopEntering) {
                return;
            }
            this.currentDate = idx;
            // 调用当前选中日期可预约的时段
            this.getTimeSlotsLimit({
                orderType: 1, //门票类型（1团队预约）
                sourceType: 2, //订单来源（2官网）
                playDay: date,
                teamType: this.teamType, //团队类型
            });
        },
        // 选择参观时段
        chooseTime(idx) {
            this.currentTime = JSON.stringify(idx);
        },
        // 获取子组件传过来的值
        getData(val) {
            this.visibleDig = val;
        },
        // 点击添加门票
        addTicket(idx) {
            let list = this.ProductList;
            list[idx].number = JSON.parse(list[idx].number) + 1;
            this.ProductList = list;
        },
        // 点击减少门票
        reduceTicket(idx) {
            let list = this.ProductList;
            // 数量等于0后不再进行操作
            if (list[idx].number == 0) {
                return;
            }
            list[idx].number = JSON.parse(list[idx].number) - 1;
            this.ProductList = list;
        },
        // 文件上传前
        beforeUpload(file) {
            let param = this.param;
            param.teamType = this.teamType;
            this.param = param;
        },
        // 名单文件上传成功的钩子
        uploadSuccess(response, file, fileList) {
            //上传成功之后清除历史记录
            this.$refs.upload.clearFiles();
            if (response.code == 0) {
                this.filePath = response.resPath;
                this.fileName = response.originalFilename;
                // 保存人员名单列表，下一页使用
                this.personList = response.data;
                // 保存预约产品人员信息
                this.products = response.products;
            } else {
                this.$message({
                    message: response.msg,
                    type: "error",
                    offset: "400",
                });
            }
        },

        // 上传导游证成功钩子
        uploadTouriseSuccess(response, file, fileList) {
            //上传成功之后清除历史记录
            this.$refs.uploadTourise.clearFiles();
            if (response.code == 0) {
                // 身份证反面
                this.reverseIdCardFileUrl = response.resPath;

                // 导游证
                // this.TourisefilePath = response.resPath;
                // this.TourisefileName = response.originalFilename;
            } else {
                this.$message({
                    message: response.msg,
                    type: "error",
                    offset: "400",
                });
            }
        },
        // 上传行程单成功钩子
        uploadTripSuccess(response, file, fileList) {
            //上传成功之后清除历史记录
            this.$refs.uploadTrip.clearFiles();
            if (response.code == 0) {
                // 身份证正面
                this.idCardFileUrl = response.resPath;

                // 行程单
                // this.TripfilePath = response.resPath;
                // this.TripfileName = response.originalFilename;
            } else {
                this.$message({
                    message: response.msg,
                    type: "error",
                    offset: "400",
                });
            }
        },
        // 上传介绍信成功钩子
        uploadLetterSuccess(response, file, fileList) {
            //上传成功之后清除历史记录
            this.$refs.uploadLetter.clearFiles();
            if (response.code == 0) {
                this.LetterfilePath = response.resPath;
                this.LetterfileName = response.originalFilename;
            } else {
                this.$message({
                    message: response.msg,
                    type: "error",
                    offset: "400",
                });
            }
        },
        uploadLetterSuccess1(response, file, fileList) {
            //上传成功之后清除历史记录
            this.$refs.uploadLetter1.clearFiles();
            if (response.code == 0) {
                this.instructionsProveFileUrl = response.resPath;
                this.instructionsProveFileUrlName = response.originalFilename;
            } else {
                this.$message({
                    message: response.msg,
                    type: "error",
                    offset: "400",
                });
            }
        },
        // 点击进入下一步
        Confirm() {
            if (
                this.teamInfo == null ||
                this.teamInfo == "" ||
                this.teamInfo == undefined ||
                !this.teamInfo.effectiveStateFlag
            ) {
                this.$message({
                    message: "请先进行团队认证！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.currentDate == -1) {
                this.$message({
                    message: "请选择参观日期！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.currentTime == null) {
                this.$message({
                    message: "请选择参观时段！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.name == "") {
                this.$message({
                    message: this.teamType == 1 ? "请输入导游姓名！" : "请输入领队人员姓名！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            // if (this.Idcard == "" && this.teamType != 1) {
            //     this.$message({
            //         message: "请输入证件号码！",
            //         type: "error",
            //         offset: "400",
            //     });
            //     return;
            // }
            if (this.phone == "") {
                this.$message({
                    message: "请输入联系电话！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (!this.userCount) {
                this.$message({
                    message: "请输入参观人数！",
                    type: "error",
                    offset: "400",
                });
                return;
            }

            // if (this.filePath == "") {
            //     this.$message({
            //         message: "请上传参观名单！",
            //         type: "error",
            //         offset: "400",
            //     });
            //     return;
            // }
            if (this.instructionsProveFileUrl == "") {
                this.$message({
                    message: "请上传承诺书！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.idCardFileUrl == "") {
                this.$message({
                    message: "请上传身份证正面照！",
                    type: "error",
                    offset: "400",
                });
                return;
            }

            if (this.reverseIdCardFileUrl == "") {
                this.$message({
                    message: "请上传身份证反面照！",
                    type: "error",
                    offset: "400",
                });
                return;
            }

            // if (this.teamType != 1 && this.LetterfilePath == '') {
            // 	this.$message({
            // 		message: '请上传介绍信！',
            // 		type: 'error',
            // 		offset: '400'
            // 	});
            // 	return
            // }
            if (!Api.isMobile(this.phone)) {
                this.$message({
                    message: "手机号码格式有误！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            // toUpperCase转换为大写
            // if (this.teamType == 0 && !IdentityCodeValid(this.Idcard.toUpperCase())) {
            //     this.$message({
            //         message: "证件号码格式有误！",
            //         type: "error",
            //         offset: "400",
            //     });
            //     return;
            // }
            this.$router.push({
                name: "TeamConfirmOrder",
                params: {
                    name: this.name,
                    Idcard: this.Idcard,
                    phone: this.phone,
                    notes: this.remark,
                    filePath: this.filePath,
                    teamType: this.teamType,
                    currentDate: this.dateList[this.currentDate].day,
                    currentTime: this.timeIntervalList[this.currentTime].id,
                    products: this.products,
                    personList: this.personList,
                    idCardFileUrl: this.idCardFileUrl,
                    reverseIdCardFileUrl: this.reverseIdCardFileUrl,
                    userCount: this.userCount,
                    application_file_url:
                        this.teamType == 1 ? this.TripfilePath : this.LetterfilePath, //介绍信、电子行程单
                    // instructions_prove_fileUrl: this.TourisefilePath, //导游证
                    instructionsProveFileUrl: this.TourisefilePath || this.instructionsProveFileUrl, //承诺书
                },
            });
            // 验证领队人员身份证和姓名是否对应（暂时注释，需要时再打开）
            // realNameAuth(this.name, this.Idcard).then(res => {
            // 	if (res.data) {
            // 		this.$router.push({
            // 			name: "TeamConfirmOrder",
            // 			params: {
            // 				name: this.name,
            // 				Idcard: this.Idcard,
            // 				phone: this.phone,
            // 				notes: this.remark,
            // 				filePath: this.filePath,
            // 				teamType: this.teamType,
            // 				currentDate: this.dateList[this.currentDate].day,
            // 				currentTime: this.timeIntervalList[this.currentTime].id,
            // 				products: this.products,
            // 				personList: this.personList,
            // 				application_file_url: this.teamType == 1 ? this.TripfilePath : this
            // 					.LetterfilePath, //介绍信、电子行程单
            // 				instructions_prove_fileUrl: this.TourisefilePath //导游证
            // 			}
            // 		})
            // 	} else {
            // 		this.$message({
            // 			message: res.msg,
            // 			type: 'error',
            // 			offset: '400'
            // 		});
            // 	}
            // })
        },
        // 下载参观名单模板
        downModel() {
            window.open(
                `${BaseUrl}/api-api/app/clientHelper/pass/downModel/v1?merchantNo=${merchantNo}&teamType=${this.teamType}`,
            );
        },
        // 下载承诺书模版
        downModel1() {
            window.open(this.teamInfo.instructionsProveFileUrl);
        },
        // 获取参观日期
        AppointmentDay(param) {
            AppointmentDay(param).then(res => {
                this.dateList = res.data;
                let date = "";
                for (let i = 0; i < this.dateList.length; i++) {
                    // 保存第一个可预约的日期，设置默认选中
                    if (
                        !this.dateList[i].reception &&
                        !this.dateList[i].stop &&
                        !this.dateList[i].stopEntering
                    ) {
                        this.currentDate = JSON.stringify(i);
                        date = this.dateList[i].day;
                        break;
                    }
                }
                this.getTimeSlotsLimit({
                    orderType: 1, //门票类型（1团队预约）
                    sourceType: 2, //订单来源（2官网）
                    playDay: date,
                    teamType: this.teamType, //团队类型
                });
            });
        },
        // 获取参观时段
        getTimeSlotsLimit(param) {
            getTimeSlotsLimit(param).then(res => {
                this.timeIntervalList = res.data;
            });
        },
        // 获取产品数据
        getProductList(param) {
            getProductList(param).then(res => {
                let list = res.data;
                for (let li of list) {
                    li.number = 0;
                }
                this.ProductList = list;
            });
        },
        // 获取登录参数
        login() {
            let param = {
                merchantNo: merchantNo,
                appId: "f780ea5b76544c1fa20da8048f1dd424",
                skey: this.skey,
            };
            login(param).then(res => {
                tool.setStore("token", res.token);
                tool.setStore("isTeam", res.isTeam);
                tool.setStore("teamType", res.teamType);
                tool.setStore("uid", res.uid);
                this.headerObj.Authorization = res.token;
                this.isTeam = res.isTeam;
                this.visibleDig = !this.isTeam;
                this.teamType = res.teamType;
                // 查询团队认证状态
                this.checkIsTeam();

                if (res.isTeam) {
                    // 获取参观日期
                    this.AppointmentDay({
                        type: this.teamType,
                    });
                    // 获取产品数据
                    this.getProductList({
                        orderType: 1, //门票类型（1团队预约）
                        sourceType: 2, //订单来源（2官网）
                        teamType: this.teamType, //团队类型
                    });
                }
            });
        },
        goApply() {
            this.visibleDig = false;
            this.$router.push("TeamInfo");
        },
    },
};
</script>

<style scoped>
.content {
    width: 1200px;
    margin: auto;
    background: #fff;
    background-size: 100%;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    padding: 24px;
    box-sizing: border-box;
}

.header {
    width: 100%;
    height: 70px;
    background-image: url(../../assets/img/step1.svg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 0 130px;
    box-sizing: border-box;
    justify-content: space-between;
    margin-bottom: 24px;
}

.header .step-item {
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #b42d0a;
}

.header .step-item img {
    width: 26px;
    height: 26px;
    margin-bottom: 6px;
}

.header .step-item img:first-child {
    width: 30px;
    height: 24px;
}

.header .step-item img:last-child {
    width: 26px;
    height: 24px;
}

.section {
    width: 100%;
}

.section .nav,
.touristlist,
.tips {
    width: 100%;
    padding: 0 60px;
    box-sizing: border-box;
    justify-content: space-between;
    margin-bottom: 24px;
}

.section .datelist,
.timeInterval,
.ticketbox {
    width: 100%;
    padding: 0 60px;
    box-sizing: border-box;
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.section .nav .nav-item {
    width: 120px;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #333;
    line-height: 16px;
}

.section .datelist .item {
    width: 120px;
    height: 80px;
    background: #fbf2e7;
    border-radius: 6px;
    border: 1px solid #bb2916;
    padding: 10px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    line-height: 20px;
    color: #bb2916;
    justify-content: center;
    position: relative;
    margin-right: 27px;
    margin-bottom: 20px;
    cursor: pointer;
}

.item .today {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 0;
    right: 0;
}

/* 不可预约样式 */
.notchecked {
    background: #f6f6f6 !important;
    border: 1px solid #eaeaea !important;
    color: #333 !important;
}

/* 日期选中样式 */
.activeDate {
    color: #ffffff !important;
    border: none !important;
    background: #bb2916 !important;
    background-size: 120px 80px !important;
    background-repeat: no-repeat !important;
}

/* 时段选中样式 */
.activeTime {
    color: #ffffff !important;
    border: none !important;
    background: #bb2916 !important;
    background-size: 120px 99px !important;
    background-repeat: no-repeat !important;
}

.timeInterval .item {
    width: 120px;
    height: 99px;
    background: #fbf2e7;
    border-radius: 6px;
    border: 1px solid #bb2916;
    padding: 10px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    line-height: 20px;
    color: #bb2916;
    justify-content: center;
    margin-right: 27px;
    margin-bottom: 20px;
    cursor: pointer;
}

.ticketbox {
    justify-content: space-between;
}

.ticketbox .item {
    width: 496px;
    height: 114px;
    border-radius: 12px;
    padding: 24px;
    box-sizing: border-box;
    background-image: url("../../assets/img/icon-ticketbg.svg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    margin-right: 20px;
    margin-bottom: 20px;
}

.ticketbox .item .cover {
    width: 66px;
    height: 66px;
    margin-right: 14px;
    border-radius: 8px;
    border: 1px solid #bb2916;
}

.ticketbox .item .name {
    font-size: 16px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
    display: flex;
    flex-direction: column;
}

.ticketbox .item .name span {
    font-size: 16px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #bb2916;
    margin-top: 14px;
}

.numbox {
    position: absolute;
    bottom: 24px;
    right: 24px;
}

.numbox img {
    width: 28px;
    height: 28px;
}

.teamInfo {
    margin-left: 60px;
}

.teamInfo .tab-item {
    padding: 0 36px;
    height: 40px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #999999;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #999999;
    margin-right: 18px;
    line-height: 40px;
    margin-bottom: 24px;
}

/* nav激活样式 */
.activeNav {
    background: #bb2916 !important;
    border: none !important;
    color: #ffffff !important;
}

.section .detail {
    margin: 24px 0;
    margin-left: 60px;
}

.detail .item {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    margin-bottom: 20px;
}

.detail .item img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
}

.line {
    width: 1038px;
    height: 6px;
    margin: 24px 0;
    margin-left: 60px;
}

.btnbox {
    justify-content: center;
}

.btnbox div {
    width: 324px;
    height: 60px;
    font-size: 22px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 60px;
    border-radius: 30px;
}

.btnbox .backbtn {
    color: #3a6e61;
    background: #ffffff;
    border: 1px solid #3a6e61;
    margin-right: 32px;
}

.btnbox .prevbtn {
    color: #ffffff;
    background: #ba2a17;
    cursor: pointer;
}

.info {
    width: 1008px;
    justify-content: space-between;
    margin-bottom: 48px;
}

.info .item {
    margin-bottom: 14px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
}

.info .item span {
    display: block;
    width: 73px;
    margin-right: 14px;
    white-space: nowrap;
    text-align: right;
    color: #333333;
}

.info .item span::before {
    content: "*";
    color: #af0b0b;
    font-size: 16px;
}

.info .leader {
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
}

.right-box {
    flex-wrap: wrap;
    justify-content: space-between;
}

.right-box .name {
    display: block;
    width: 83px;
    margin-right: 14px;
    white-space: nowrap;
    text-align: right;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
}

.uploadFile .name::before {
    content: "*";
    color: #af0b0b;
    font-size: 16px;
}

.right-box .uploadFile {
    position: relative;
    margin-bottom: 40px;
}

.right-box .uploadbox {
    width: 398px;
    height: 148px;
    background: #f5f5f5;
    border-radius: 6px;
    justify-content: center;
}
.uploadbox-title {
    color: #000 !important;
}
.uploadbox-title:hover {
    color: #b42d0a !important;
}
.uploadbox .fileName {
    width: 260px;
    font-size: 14px;
    color: #333333;
    margin: auto;
}

.right-box .uploadbox img {
    width: 40px;
    height: 40px;
    margin-bottom: 4px;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.download {
    position: absolute;
    bottom: -24px;
    left: 390px;
}

.download span {
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #b42d0a;
    text-decoration: underline;
    /*文字添加下划线*/
}

.download img {
    width: 18px;
    height: 18px;
    margin-right: 6px;
}

/deep/ .numbox .el-input {
    width: 62px;
    height: 32px;
    margin: 0 18px;
}

/deep/ .numbox .el-input__inner {
    width: 62px;
    height: 32px;
    background: #f2f8f6;
    border-radius: 6px;
    border: 1px solid #bb2916;
    font-size: 14px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    text-align: center;
    padding: 0 10px;
    box-sizing: border-box;
}

/deep/ .shcoolName .el-input {
    width: 640px;
    height: 40px;
}

/deep/ .leader .el-input {
    width: 398px;
    height: 40px;
}

/deep/ .textarea1 .el-textarea {
    width: 398px;
    height: 148px;
    margin-bottom: 40px;
}

/deep/ .textarea1 .el-textarea__inner {
    width: 398px;
    height: 148px;
    background: #fafafa;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

/deep/ .textarea .el-textarea {
    width: 915px;
    height: 148px;
    margin-bottom: 40px;
}

/deep/ .textarea .el-textarea__inner {
    width: 915px;
    height: 148px;
    background: #fafafa;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

/deep/ .item .el-input__inner {
    background: #fafafa;
    border-radius: 6px;
    border: 1px solid #e9e9e9;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

/deep/ .el-input__inner:focus {
    border-color: #bb2916;
}
</style>
